import(/* webpackMode: "eager" */ "/home/harmo/projects/Synetudes/src/app/error.tsx");
